<template>
  <v-form>
    <div class="az-form-content dados-gerais">
      <v-container fluid grid-list-xl white>
        <painel-compra-direta-visualizacao v-model="dadosGeraisVisualizacao"
                                           :tempoRandomicoLance="tempoRandomicoLance"
                                           :ehALei14_133="ehALei14_133"
                                            class="mb-3"/>

        <painel-anexo-visualizacao v-model="dadosGeraisVisualizacao.anexos"
                                   :situacaoCompraDireta="dadosGeraisVisualizacao.situacao"
                                   :paginas="null"
                                   :paginacao="null"
                                   @downloadAnexo="tratarEventDownloadAnexo"/>
      </v-container>
    </div>
  </v-form>
</template>

<script>
import {actionTypes} from '@/core/constants'
import PainelAnexoVisualizacao from '@/views/pages/commons/detalhe-compra-direta/etapas-visualizacao/painel-anexo/PainelAnexoVisualizacao'
import {mapState} from 'vuex'
import PainelCompraDiretaVisualizacao from '@/views/pages/commons/detalhe-compra-direta/etapas-visualizacao/painel-compra-direta/PainelCompraDiretaVisualizacao.vue'

export default {
    name: 'CompraDiretaVisualizacaoDadosGerais',
    components: {
        PainelCompraDiretaVisualizacao,
        PainelAnexoVisualizacao,
    },
    data() {
        return {
            dadosGeraisVisualizacao: {
                anexos: []
            },
            compraDiretaId: null,
            documentos: [],
            exibirAnexoEdicao: false,
            anexoId: null,
            situacaoAnexo: null,
            mostrarDialogoAtivoInativo: false,
            titulo: '',
            mensagem: '',
            eventos: null,
            mostrarModalSuspensao: false,
        }
    },
    computed: {
        ...mapState(['compraDireta']),
        tempoRandomicoLance() {
            return null
        },
        ehALei14_133(){
            return this.ehLei14_133(this.compraDireta.amparoLegal)
        },
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDadosGerais()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    watch: {
        'compraDireta': {
            handler(novoValor) {
                this.dadosGeraisVisualizacao = novoValor
            },
            deep: true
        }
    },
    methods: {
        async buscarDadosGerais() {
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS_PUBLICO, this.compraDiretaId)
            this.dadosGeraisVisualizacao = this.$store.state.compraDireta
            this.anexos = this.compraDireta.anexos
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        compraDiretaSituacaoLegal(){
            return ['AGUARDANDO_ABERTURA', 'ABERTA', 'ENCERRADA', 'EM_ANALISE', 'REANALISE'].includes(this.dadosGeraisVisualizacao.situacao)
        },
        ehRecursoFederalETransferenciaVoluntaria()
        {
            return (this.dadosGeraisVisualizacao.recursoFederal && this.ehTransferenciaVoluntarios())
        },
        ehTransferenciaVoluntarios(){
            return this.dadosGeraisVisualizacao.tipoTransferencia === 'VOLUNTARIAS'
        },
        ehLei14_133(amparoLegal) {
            let lei = amparoLegal && amparoLegal.lei
            return !!(lei && lei.includes('14.133/2021'))
        },
        async tratarEventDownloadAnexo(anexoInfo){
            const anexoDoc = anexoInfo.anexo
            if(anexoDoc.id && anexoDoc.uri){
                await this.$store.dispatch(actionTypes.DOWNLOAD_ANEXO, anexoDoc)
            } else if(anexoDoc.idVirtualizado){
                const dados = {
                    compraDiretaId: this.compraDiretaId,
                    idVirtualizado: anexoDoc.idVirtualizado,
                    nomeArquivo: anexoDoc.nomeDocumento,
                    opcaoDownloadVirtualizacao: anexoInfo.tipoDownload,
                    noProcessoDigital: anexoDoc.noProcessoDigital
                }
                await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTO_VIRTUALIZADO, dados)
            }
        },
    }
}
</script>

<style scoped lang="stylus">

</style>
